! function() {
	var t = {
			432: function(t) {
				function e(t, e, n) {
					var o, i, r, s, a;

					function c() {
						var l = Date.now() - s;
						l < e && l >= 0 ? o = setTimeout(c, e - l) : (o = null, n || (a = t.apply(r, i), r = i = null))
					}
					null == e && (e = 100);
					var l = function() {
						r = this, i = arguments, s = Date.now();
						var l = n && !o;
						return o || (o = setTimeout(c, e)), l && (a = t.apply(r, i), r = i = null), a
					};
					return l.clear = function() {
						o && (clearTimeout(o), o = null)
					}, l.flush = function() {
						o && (a = t.apply(r, i), r = i = null, clearTimeout(o), o = null)
					}, l
				}
				e.debounce = e, t.exports = e
			},
			653: function(t) {
				if ("undefined" != typeof Element && !Element.prototype.matches) {
					var e = Element.prototype;
					e.matches = e.matchesSelector || e.mozMatchesSelector || e.msMatchesSelector || e.oMatchesSelector || e.webkitMatchesSelector
				}
				t.exports = function(t, e) {
					for (; t && 9 !== t.nodeType;) {
						if ("function" == typeof t.matches && t.matches(e)) return t;
						t = t.parentNode
					}
				}
			},
			893: function(t, e, n) {
				var o = n(653);

				function i(t, e, n, o, i) {
					var s = r.apply(this, arguments);
					return t.addEventListener(n, s, i), {
						destroy: function() {
							t.removeEventListener(n, s, i)
						}
					}
				}

				function r(t, e, n, i) {
					return function(n) {
						n.delegateTarget = o(n.target, e), n.delegateTarget && i.call(t, n)
					}
				}
				t.exports = function(t, e, n, o, r) {
					return "function" == typeof t.addEventListener ? i.apply(null, arguments) : "function" == typeof n ? i.bind(null, document).apply(null, arguments) : ("string" == typeof t && (t = document.querySelectorAll(t)), Array.prototype.map.call(t, (function(t) {
						return i(t, e, n, o, r)
					})))
				}
			},
			489: function() {
				! function(t, e) {
					"use strict";
					if ("IntersectionObserver" in t && "IntersectionObserverEntry" in t && "intersectionRatio" in t.IntersectionObserverEntry.prototype) "isIntersecting" in t.IntersectionObserverEntry.prototype || Object.defineProperty(t.IntersectionObserverEntry.prototype, "isIntersecting", {
						get: function() {
							return this.intersectionRatio > 0
						}
					});
					else {
						var n = [];
						i.prototype.THROTTLE_TIMEOUT = 100, i.prototype.POLL_INTERVAL = null, i.prototype.USE_MUTATION_OBSERVER = !0, i.prototype.observe = function(t) {
							if (!this._observationTargets.some((function(e) {
									return e.element == t
								}))) {
								if (!t || 1 != t.nodeType) throw new Error("target must be an Element");
								this._registerInstance(), this._observationTargets.push({
									element: t,
									entry: null
								}), this._monitorIntersections(), this._checkForIntersections()
							}
						}, i.prototype.unobserve = function(t) {
							this._observationTargets = this._observationTargets.filter((function(e) {
								return e.element != t
							})), this._observationTargets.length || (this._unmonitorIntersections(), this._unregisterInstance())
						}, i.prototype.disconnect = function() {
							this._observationTargets = [], this._unmonitorIntersections(), this._unregisterInstance()
						}, i.prototype.takeRecords = function() {
							var t = this._queuedEntries.slice();
							return this._queuedEntries = [], t
						}, i.prototype._initThresholds = function(t) {
							var e = t || [0];
							return Array.isArray(e) || (e = [e]), e.sort().filter((function(t, e, n) {
								if ("number" != typeof t || isNaN(t) || t < 0 || t > 1) throw new Error("threshold must be a number between 0 and 1 inclusively");
								return t !== n[e - 1]
							}))
						}, i.prototype._parseRootMargin = function(t) {
							var e = (t || "0px").split(/\s+/).map((function(t) {
								var e = /^(-?\d*\.?\d+)(px|%)$/.exec(t);
								if (!e) throw new Error("rootMargin must be specified in pixels or percent");
								return {
									value: parseFloat(e[1]),
									unit: e[2]
								}
							}));
							return e[1] = e[1] || e[0], e[2] = e[2] || e[0], e[3] = e[3] || e[1], e
						}, i.prototype._monitorIntersections = function() {
							this._monitoringIntersections || (this._monitoringIntersections = !0, this.POLL_INTERVAL ? this._monitoringInterval = setInterval(this._checkForIntersections, this.POLL_INTERVAL) : (r(t, "resize", this._checkForIntersections, !0), r(e, "scroll", this._checkForIntersections, !0), this.USE_MUTATION_OBSERVER && "MutationObserver" in t && (this._domObserver = new MutationObserver(this._checkForIntersections), this._domObserver.observe(e, {
								attributes: !0,
								childList: !0,
								characterData: !0,
								subtree: !0
							}))))
						}, i.prototype._unmonitorIntersections = function() {
							this._monitoringIntersections && (this._monitoringIntersections = !1, clearInterval(this._monitoringInterval), this._monitoringInterval = null, s(t, "resize", this._checkForIntersections, !0), s(e, "scroll", this._checkForIntersections, !0), this._domObserver && (this._domObserver.disconnect(), this._domObserver = null))
						}, i.prototype._checkForIntersections = function() {
							var e = this._rootIsInDom(),
								n = e ? this._getRootRect() : {
									top: 0,
									bottom: 0,
									left: 0,
									right: 0,
									width: 0,
									height: 0
								};
							this._observationTargets.forEach((function(i) {
								var r = i.element,
									s = a(r),
									c = this._rootContainsTarget(r),
									l = i.entry,
									u = e && c && this._computeTargetAndRootIntersection(r, n),
									d = i.entry = new o({
										time: t.performance && performance.now && performance.now(),
										target: r,
										boundingClientRect: s,
										rootBounds: n,
										intersectionRect: u
									});
								l ? e && c ? this._hasCrossedThreshold(l, d) && this._queuedEntries.push(d) : l && l.isIntersecting && this._queuedEntries.push(d) : this._queuedEntries.push(d)
							}), this), this._queuedEntries.length && this._callback(this.takeRecords(), this)
						}, i.prototype._computeTargetAndRootIntersection = function(n, o) {
							if ("none" != t.getComputedStyle(n).display) {
								for (var i, r, s, c, u, d, h, p, f = a(n), v = l(n), m = !1; !m;) {
									var b = null,
										g = 1 == v.nodeType ? t.getComputedStyle(v) : {};
									if ("none" == g.display) return;
									if (v == this.root || v == e ? (m = !0, b = o) : v != e.body && v != e.documentElement && "visible" != g.overflow && (b = a(v)), b && (i = b, r = f, void 0, void 0, void 0, void 0, void 0, void 0, s = Math.max(i.top, r.top), c = Math.min(i.bottom, r.bottom), u = Math.max(i.left, r.left), p = c - s, !(f = (h = (d = Math.min(i.right, r.right)) - u) >= 0 && p >= 0 && {
											top: s,
											bottom: c,
											left: u,
											right: d,
											width: h,
											height: p
										}))) break;
									v = l(v)
								}
								return f
							}
						}, i.prototype._getRootRect = function() {
							var t;
							if (this.root) t = a(this.root);
							else {
								var n = e.documentElement,
									o = e.body;
								t = {
									top: 0,
									left: 0,
									right: n.clientWidth || o.clientWidth,
									width: n.clientWidth || o.clientWidth,
									bottom: n.clientHeight || o.clientHeight,
									height: n.clientHeight || o.clientHeight
								}
							}
							return this._expandRectByRootMargin(t)
						}, i.prototype._expandRectByRootMargin = function(t) {
							var e = this._rootMarginValues.map((function(e, n) {
									return "px" == e.unit ? e.value : e.value * (n % 2 ? t.width : t.height) / 100
								})),
								n = {
									top: t.top - e[0],
									right: t.right + e[1],
									bottom: t.bottom + e[2],
									left: t.left - e[3]
								};
							return n.width = n.right - n.left, n.height = n.bottom - n.top, n
						}, i.prototype._hasCrossedThreshold = function(t, e) {
							var n = t && t.isIntersecting ? t.intersectionRatio || 0 : -1,
								o = e.isIntersecting ? e.intersectionRatio || 0 : -1;
							if (n !== o)
								for (var i = 0; i < this.thresholds.length; i++) {
									var r = this.thresholds[i];
									if (r == n || r == o || r < n != r < o) return !0
								}
						}, i.prototype._rootIsInDom = function() {
							return !this.root || c(e, this.root)
						}, i.prototype._rootContainsTarget = function(t) {
							return c(this.root || e, t)
						}, i.prototype._registerInstance = function() {
							n.indexOf(this) < 0 && n.push(this)
						}, i.prototype._unregisterInstance = function() {
							var t = n.indexOf(this); - 1 != t && n.splice(t, 1)
						}, t.IntersectionObserver = i, t.IntersectionObserverEntry = o
					}

					function o(t) {
						this.time = t.time, this.target = t.target, this.rootBounds = t.rootBounds, this.boundingClientRect = t.boundingClientRect, this.intersectionRect = t.intersectionRect || {
							top: 0,
							bottom: 0,
							left: 0,
							right: 0,
							width: 0,
							height: 0
						}, this.isIntersecting = !!t.intersectionRect;
						var e = this.boundingClientRect,
							n = e.width * e.height,
							o = this.intersectionRect,
							i = o.width * o.height;
						this.intersectionRatio = n ? Number((i / n).toFixed(4)) : this.isIntersecting ? 1 : 0
					}

					function i(t, e) {
						var n, o, i, r = e || {};
						if ("function" != typeof t) throw new Error("callback must be a function");
						if (r.root && 1 != r.root.nodeType) throw new Error("root must be an Element");
						this._checkForIntersections = (n = this._checkForIntersections.bind(this), o = this.THROTTLE_TIMEOUT, i = null, function() {
							i || (i = setTimeout((function() {
								n(), i = null
							}), o))
						}), this._callback = t, this._observationTargets = [], this._queuedEntries = [], this._rootMarginValues = this._parseRootMargin(r.rootMargin), this.thresholds = this._initThresholds(r.threshold), this.root = r.root || null, this.rootMargin = this._rootMarginValues.map((function(t) {
							return t.value + t.unit
						})).join(" ")
					}

					function r(t, e, n, o) {
						"function" == typeof t.addEventListener ? t.addEventListener(e, n, o || !1) : "function" == typeof t.attachEvent && t.attachEvent("on" + e, n)
					}

					function s(t, e, n, o) {
						"function" == typeof t.removeEventListener ? t.removeEventListener(e, n, o || !1) : "function" == typeof t.detatchEvent && t.detatchEvent("on" + e, n)
					}

					function a(t) {
						var e;
						try {
							e = t.getBoundingClientRect()
						} catch (t) {}
						return e ? (e.width && e.height || (e = {
							top: e.top,
							right: e.right,
							bottom: e.bottom,
							left: e.left,
							width: e.right - e.left,
							height: e.bottom - e.top
						}), e) : {
							top: 0,
							bottom: 0,
							left: 0,
							right: 0,
							width: 0,
							height: 0
						}
					}

					function c(t, e) {
						for (var n = e; n;) {
							if (n == t) return !0;
							n = l(n)
						}
						return !1
					}

					function l(t) {
						var e = t.parentNode;
						return e && 11 == e.nodeType && e.host ? e.host : e
					}
				}(window, document)
			},
			661: function() {
				window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = function(t, e) {
					e = e || window;
					for (var n = 0; n < this.length; n++) t.call(e, this[n], n, this)
				})
			},
			959: function(t, e, n) {
				var o;

				function i(t) {
					return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
						return typeof t
					} : function(t) {
						return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
					}, i(t)
				}
				t = n.nmd(t),
					function(r, s) {
						"use strict";
						var a = {};
						r.PubSub ? (a = r.PubSub, console.warn("PubSub already loaded, using existing version")) : (r.PubSub = a, function(t) {
							var e = {},
								n = -1;

							function o(t, e, n) {
								try {
									t(e, n)
								} catch (t) {
									setTimeout(function(t) {
										return function() {
											throw t
										}
									}(t), 0)
								}
							}

							function r(t, e, n) {
								t(e, n)
							}

							function s(t, n, i, s) {
								var a, c = e[n],
									l = s ? r : o;
								if (Object.prototype.hasOwnProperty.call(e, n))
									for (a in c) Object.prototype.hasOwnProperty.call(c, a) && l(c[a], t, i)
							}

							function a(t) {
								var n = String(t);
								return Boolean(Object.prototype.hasOwnProperty.call(e, n) && function(t) {
									var e;
									for (e in t)
										if (Object.prototype.hasOwnProperty.call(t, e)) return !0;
									return !1
								}(e[n]))
							}

							function c(t, e, n, o) {
								var r = function(t, e, n) {
									return function() {
										var o = String(t),
											i = o.lastIndexOf(".");
										for (s(t, t, e, n); - 1 !== i;) i = (o = o.substr(0, i)).lastIndexOf("."), s(t, o, e, n);
										s(t, "*", e, n)
									}
								}(t = "symbol" === i(t) ? t.toString() : t, e, o);
								return !! function(t) {
									for (var e = String(t), n = a(e) || a("*"), o = e.lastIndexOf("."); !n && -1 !== o;) o = (e = e.substr(0, o)).lastIndexOf("."), n = a(e);
									return n
								}(t) && (!0 === n ? r() : setTimeout(r, 0), !0)
							}
							t.publish = function(e, n) {
								return c(e, n, !1, t.immediateExceptions)
							}, t.publishSync = function(e, n) {
								return c(e, n, !0, t.immediateExceptions)
							}, t.subscribe = function(t, o) {
								if ("function" != typeof o) return !1;
								t = "symbol" === i(t) ? t.toString() : t, Object.prototype.hasOwnProperty.call(e, t) || (e[t] = {});
								var r = "uid_" + String(++n);
								return e[t][r] = o, r
							}, t.subscribeAll = function(e) {
								return t.subscribe("*", e)
							}, t.subscribeOnce = function(e, n) {
								var o = t.subscribe(e, (function() {
									t.unsubscribe(o), n.apply(this, arguments)
								}));
								return t
							}, t.clearAllSubscriptions = function() {
								e = {}
							}, t.clearSubscriptions = function(t) {
								var n;
								for (n in e) Object.prototype.hasOwnProperty.call(e, n) && 0 === n.indexOf(t) && delete e[n]
							}, t.countSubscriptions = function(t) {
								var n, o, i = 0;
								for (n in e)
									if (Object.prototype.hasOwnProperty.call(e, n) && 0 === n.indexOf(t)) {
										for (o in e[n]) i++;
										break
									} return i
							}, t.getSubscriptions = function(t) {
								var n, o = [];
								for (n in e) Object.prototype.hasOwnProperty.call(e, n) && 0 === n.indexOf(t) && o.push(n);
								return o
							}, t.unsubscribe = function(n) {
								var o, i, r, s = "string" == typeof n && (Object.prototype.hasOwnProperty.call(e, n) || function(t) {
										var n;
										for (n in e)
											if (Object.prototype.hasOwnProperty.call(e, n) && 0 === n.indexOf(t)) return !0;
										return !1
									}(n)),
									a = !s && "string" == typeof n,
									c = "function" == typeof n,
									l = !1;
								if (!s) {
									for (o in e)
										if (Object.prototype.hasOwnProperty.call(e, o)) {
											if (i = e[o], a && i[n]) {
												delete i[n], l = n;
												break
												
											}
											if (c)
												for (r in i) Object.prototype.hasOwnProperty.call(i, r) && i[r] === n && (delete i[r], l = !0)
										} return l
								}
								t.clearSubscriptions(n)
							}
						}(a)), "object" === i(e) ? (void 0 !== t && t.exports && (e = t.exports = a), e.PubSub = a, t.exports = e = a) : void 0 === (o = function() {
							return a
						}.call(e, n, e, t)) || (t.exports = o)
					}("object" === ("undefined" == typeof window ? "undefined" : i(window)) && window || this)
			}
		},
		e = {};

	function n(o) {
		var i = e[o];
		if (void 0 !== i) return i.exports;
		var r = e[o] = {
			id: o,
			loaded: !1,
			exports: {}
		};
		return t[o].call(r.exports, r, r.exports, n), r.loaded = !0, r.exports
	}
	n.n = function(t) {
			var e = t && t.__esModule ? function() {
				return t.default
			} : function() {
				return t
			};
			return n.d(e, {
				a: e
			}), e
		}, n.d = function(t, e) {
			for (var o in e) n.o(e, o) && !n.o(t, o) && Object.defineProperty(t, o, {
				enumerable: !0,
				get: e[o]
			})
		}, n.o = function(t, e) {
			return Object.prototype.hasOwnProperty.call(t, e)
		}, n.nmd = function(t) {
			return t.paths = [], t.children || (t.children = []), t
		},
		function() {
			"use strict";

			function t(t) {
				var e = document.createElement("div");
				return e.innerHTML = t.trim(), e.childNodes
			}

			function e(t) {
				var e = t.scrollHeight;
				e > 0 && (t.style.height = e + "px"), t.addEventListener("transitionend", (function e() {
					t.removeEventListener("transitionend", e), t.style.height = null
				}))
			}
			var o = n(959),
				i = n.n(o),
				r = "page-content/change",
				s = "image/loaded",
				a = "modal/opened",
				c = "modal/display";

			function l(t, e) {
				var n;
				return window.CustomEvent ? n = new CustomEvent(t, {
					detail: {
						data: e
					},
					bubbles: !0
				}) : (n = document.createEvent("CustomEvent")).initCustomEvent(t, !0, !0, {
					data: e
				}), n
			}
			n(432);
			var u = n(893),
				d = n.n(u);

			function h(t, e, n) {
				var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
				d()(document.body, e, t, (function(t) {
					t.preventDefault(), t.stopPropagation();
					var e = l(n, o);
					t.target.dispatchEvent(e)
				}), !1)
			}
			n(661), n(489);
			var p, f = {
					root: null,
					rootMargin: "10px 0px 10px 0px",
					threshold: .1
				},
				v = "is_Sticky";

			function m(t, e) {
				t.forEach((function(t) {
					t.intersectionRatio <= f.threshold ? document.body.classList.add(v) : document.body.classList.remove(v)
				}))
			}
			var b = function() {
				! function() {
					p = new IntersectionObserver(m, f);
					var t = document.querySelectorAll(".cp_TopMarker");
					if (t) {
						var e = t[t.length - 1];
						e && p.observe(e)
					}
				}()
			};

			function g(t, e) {
				for (var n = 0; n < e.length; n++) {
					var o = e[n];
					o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o)
				}
			}
			var y = "nav_Visible",
				_ = function() {
					function t(e) {
						! function(t, e) {
							if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
						}(this, t), this.menuToggle = e, this.pageHeader = document.querySelector(".ob_PageSection--header"), this.navMenu = document.querySelector(".cp_MainNav__menu--level-0"), this.bindCustomMessageEvents(), this.subscribeToEvents(), this.menuToggle.setAttribute("aria-expanded", !1), this.menuToggle.classList.add("collapsed")
					}
					var e, n;
					return e = t, (n = [{
						key: "toggleMenu",
						value: function() {
							this.menuToggle.classList.contains("collapsed") ? this.openMenu() : this.closeMenu()
						}
					}, {
						key: "openMenu",
						value: function() {
							document.body.classList.add(y), this.menuToggle.classList.remove("collapsed"), this.menuToggle.setAttribute("aria-expanded", !0), this.navMenu.setAttribute("aria-expanded", !0)
						}
					}, {
						key: "closeMenu",
						value: function() {
							document.body.classList.remove(y), this.menuToggle.classList.add("collapsed"), this.menuToggle.setAttribute("aria-expanded", !1), this.navMenu.setAttribute("aria-expanded", !1)
						}
					}, {
						key: "subscribeToEvents",
						value: function() {}
					}, {
						key: "bindCustomMessageEvents",
						value: function() {
							this.menuToggle.addEventListener("toggleMainNav", this.toggleMenu.bind(this)), this.menuToggle.addEventListener("openMainNav", this.openMenu.bind(this)), this.menuToggle.addEventListener("closeMainNav", this.closeMenu.bind(this))
						}
					}]) && g(e.prototype, n), Object.defineProperty(e, "prototype", {
						writable: !1
					}), t
				}(),
				E = ".cp_MainNav__toggle",
				w = function() {
					var t;
					h("click", E, "toggleMainNav"), t = document.querySelectorAll(E), Array.prototype.forEach.call(t, (function(t) {
						new _(t)
					}))
				};

			function M(t, e) {
				if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
			}

			function k(t, e) {
				for (var n = 0; n < e.length; n++) {
					var o = e[n];
					o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o)
				}
			}

			function T(t, e, n) {
				return e && k(t.prototype, e), n && k(t, n), Object.defineProperty(t, "prototype", {
					writable: !1
				}), t
			}
			var O = "[data-modal-source]",
				S = ".cp_Modal__closeLink",
				L = document.getElementsByTagName("body")[0],
				I = function() {
					function e(n, o, r) {
						M(this, e), this.modal = t('\n  <div class="cp_Modal" aria-modal="true">\n    <div id="confirmation-popup" class="cp_Modal__inner">\n      <div class="cp_Modal__content">\n        <div class="cp_Modal__close">\n          <a class="cp_Modal__closeLink" href="#" title="Close this modal">Close</a>\n        </div>\n      </div>\n    </div>\n  </div>').item(0), this.modalScreen = t("<div class='cp_ModalScreen'></div>").item(0), this.modalID = r, this.modalType = o, this.modalContent = n, this.closeButton = this.modal.querySelector(S), this.bindCustomMessageEvents(), this.subscribeToEvents(), L.appendChild(this.modal), L.appendChild(this.modalScreen), "support" === this.modalType && this.displaySmartImageInModal(), i().publish(a)
					}
					return T(e, [{
						key: "displaySmartImageInModal",
						value: function() {
							L.classList.add("cp_Modal--image"), this.modal.querySelector(".cp_Modal__content").appendChild(this.modalContent), this.activateModal()
						}
					}, {
						key: "positionModal",
						value: function() {
							L.classList.add("modal_Displayed")
						}
					}, {
						key: "activateModal",
						value: function() {
							L.classList.add("modal_Loaded"), this.positionModal()
						}
					}, {
						key: "closeModal",
						value: function() {
							L.removeChild(this.modal), L.removeChild(this.modalScreen)
						}
					}, {
						key: "bindCustomMessageEvents",
						value: function() {
							this.modal.addEventListener("closeModal", this.closeModal.bind(this)), this.modal.addEventListener("updatelayout", this.positionModal.bind(this)), this.modal.addEventListener("activateModal", this.activateModal.bind(this)), this.modalScreen.addEventListener("closeModal", this.closeModal.bind(this))
						}
					}, {
						key: "subscribeToEvents",
						value: function() {
							var t = this;
							i().subscribe(s, (function() {
								t.modal.dispatchEvent(l("activateModal"))
							}))
						}
					}]), e
				}(),
				C = function() {
					function t() {
						M(this, t), this.modalLinkContent = document.createElement("div"), this.modalLinkContent.classList.add("cp_Modal__contentHolder"), this.subscribeToEvents()
					}
					return T(t, [{
						key: "createModalContent",
						value: function(t) {
							var e, n = t,
								o = n.getAttribute("id") || "unidentified",
								i = (n.getAttribute("href"), n.dataset.modalSource);
							this.modalLinkContent.innerHTML = "", "support" === i && (e = '<div class="cp_Redirect">\n        <div class="cp_Redirect__intro">\n          <h3>Поддержка</h3>\n          <p>Вы были переадресованы на наш основной сайт для региона EMEA. Для получения информации, специфичной для российского рынка, просьба заполнить форму для обратной связи</p>\n        </div>\n        <div class="cp_Redirect__actions">\n        <div class="cp_Redirect__action">\n          <p>Продолжить поддержку</p>\n          <a href="https://www.resideo.com/us/en/support/" class="ob_Button">Поддержка</a>\n        </div>\n        <div class="cp_Redirect__action">\n        <p>Продолжить связываться с нами</p>\n        <a href="/contact-us/" class="ob_Button">Связаться с нами</a>\n        </div>\n        </div>\n      </div>'), e && (this.modalLinkContent.innerHTML = e, this.createModal(i, o))
						}
					}, {
						key: "createModal",
						value: function(t, e) {
							new I(this.modalLinkContent, t, e)
						}
					}, {
						key: "subscribeToEvents",
						value: function() {
							var t = this;
							i().subscribe(c, (function(e, n) {
								var o;
								(o = n.target.matches(O) ? n.target : n.target.closest(O)) && t.createModalContent(o)
							}))
						}
					}]), t
				}();
			var x = function() {
				var t;
				h("click", S, "closeModal"), h("click", ".cp_ModalScreen", "closeModal"), t = c, d()(document.body, "[data-modal-source]", "click", (function(e) {
					e.preventDefault(), e.stopPropagation(), i().publish(t, e)
				}), !1), new C
			};

			function R(t, e) {
				for (var n = 0; n < e.length; n++) {
					var o = e[n];
					o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o)
				}
			}
			var P = "[data-showhide=component] [data-showhide=toggle], .cp_MainNav__menu--level-0 > .cp_MainNav__menuItem--expanded > a, .cp_BlogFilter__cat.active .cp_BlogFilter__catLink",
				A = "is_Open",
				N = function() {
					function t(e) {
						! function(t, e) {
							if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
						}(this, t), this.element = e, this.action = this.element.querySelectorAll(P)[0], this.content = this.element.querySelectorAll("[data-showhide=content], .cp_MainNav__menu--level-0 > .cp_MainNav__menuItem--expanded > .cp_MainNav__menu, .cp_BlogFilter__list")[0], this.config = this.element.getAttribute("data-showhide-config") || {}, this.animate = this.config.animate || !1, this.speed = this.config.speed || 200, this.startState = this.config.open || !1, this.isNav = this.action.parentElement.classList.contains("cp_MainNav__menuItem--expanded"), this.bindCustomMessageEvents(), this.subscribeToEvents(), this.setStartState()
					}
					var n, o;
					return n = t, (o = [{
						key: "toggleControl",
						value: function(t) {
							t.preventDefault(), this.element.classList.contains(A) ? (this.animate && function(t) {
								var e = t.scrollHeight;
								t.style.height = e + "px";
								var n = t.style.transition;
								t.style.transition = "", window.requestAnimationFrame((function() {
									t.style.height = e + "px", t.style.transition = n, window.requestAnimationFrame((function() {
										t.style.height = "0px"
									}))
								}))
							}(this.content), this.element.classList.remove(A)) : (this.animate && e(this.content), this.isNav && i().publish("nav/updated", this.action), this.element.classList.add(A)), i().publish(r)
						}
					}, {
						key: "closeControl",
						value: function() {
							window.console.log("close"), this.element.classList.remove(A)
						}
					}, {
						key: "handleCloseEvent",
						value: function(t) {
							t.preventDefault(), window.console.log("close event"), this.closeControl()
						}
					}, {
						key: "setStartState",
						value: function() {
							!0 === this.startState && (this.animate && e(this.content), this.element.classList.add(A))
						}
					}, {
						key: "bindCustomMessageEvents",
						value: function() {
							this.element.addEventListener("toggleShowHide", this.toggleControl.bind(this)), this.element.addEventListener("closeShowHide", this.handleCloseEvent.bind(this))
						}
					}, {
						key: "subscribeToEvents",
						value: function() {
							var t = this;
							i().subscribe("nav/updated", (function(e, n) {
								n !== t.action && t.element.dispatchEvent(l("closeShowHide"))
							}))
						}
					}]) && R(n.prototype, o), Object.defineProperty(n, "prototype", {
						writable: !1
					}), t
				}(),
				j = function() {
					h("click", P, "toggleShowHide");
					var t = document.querySelectorAll("[data-showhide=component], .cp_MainNav__menu--level-0 > .cp_MainNav__menuItem--expanded, .cp_BlogFilter");
					Array.prototype.forEach.call(t, (function(t) {
						new N(t)
					}))
				};

			function B(t, e) {
				for (var n = 0; n < e.length; n++) {
					var o = e[n];
					o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o)
				}
			}
			var q, D = "is_Visible",
				F = function() {
					function t(e) {
						! function(t, e) {
							if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
						}(this, t), this.banner = e, this.acceptButton = this.banner.querySelector("#goodCookieAccept"), this.rejectButton = this.banner.querySelector("#goodCookieReject"), this.localConsent = null, this.setDisplay(), "function" == typeof getCookie && (this.localConsent = this.getCookie("trackingConsent")), this.bindButtonEvents(), this.setDisplay()
					}
					var e, n;
					return e = t, (n = [{
						key: "setCookie",
						value: function(t, e, n) {
							var o = "";
							if (n) {
								var i = new Date;
								i.setTime(i.getTime() + 24 * n * 60 * 60 * 1e3), o = "; expires=" + i.toUTCString()
							}
							document.cookie = t + "=" + (e || "") + o + "; path=/"
						}
					}, {
						key: "getCookie",
						value: function(t) {
							for (var e = t + "=", n = document.cookie.split(";"), o = 0; o < n.length; o++) {
								for (var i = n[o];
									" " == i.charAt(0);) i = i.substring(1, i.length);
								if (0 == i.indexOf(e)) return i.substring(e.length, i.length)
							}
							return null
						}

					}, {
						key: "setDisplay",
						value: function() {
							null !== this.localConsent ? this.banner.parentNode.removeChild(this.banner) : this.banner.classList.add(D)
						}
					}, {
						key: "setAcceptStatus",
						value: function(t) {
							t.preventDefault(), gtag("consent", "update", {
								ad_storage: "denied",
								analytics_storage: "granted"
							}), this.setCookie("trackingConsent", "yes", 365), this.removeBanner()
						}
					}, {
						key: "setRejectStatus",
						value: function(t) {
							t.preventDefault(), gtag("consent", "update", {
								ad_storage: "denied",
								analytics_storage: "denied"
							}), this.setCookie("trackingConsent", "no", 365), this.removeBanner()
						}
					}, {
						key: "removeBanner",
						value: function() {
							var t = this;
							this.banner.classList.remove(D), setTimeout((function() {
								t.banner.parentNode.removeChild(t.banner)
							}), 1e3)
						}
					}, {
						key: "bindButtonEvents",
						value: function() {
							this.acceptButton && this.acceptButton.addEventListener("click", this.setAcceptStatus.bind(this)), this.rejectButton && this.rejectButton.addEventListener("click", this.setRejectStatus.bind(this))
						}
					}]) && B(e.prototype, n), Object.defineProperty(e, "prototype", {
						writable: !1
					}), t
				}(),

				H = function() {
					function getCookie(cookieName) {
						const cookies = document.cookie.split(';');
						for (const cookie of cookies) {
							const [name, value] = cookie.trim().split('=');
							if (name === cookieName) {
								return decodeURIComponent(value);
							}
						}
						return null;
					}
					if (getCookie("trackingConsent") != 'yes'){
					var t = document.querySelector("#goodCookieConsent");
					new F(t)
					}
				};
			q = function() {
				b(), w(), x(), j(), H();
				for (var t = document.getElementsByClassName("map__Link"), e = 0, n = t.length; e < n; e++) t[e].addEventListener("click", (function(t) {
					t.preventDefault();
					var e = t.target.getAttribute("href"),
						n = e.replace("https", "maps"); - 1 != navigator.platform.indexOf("iPhone") || -1 != navigator.platform.indexOf("iPod") || -1 != navigator.platform.indexOf("iPad") ? window.open(n) : window.open(e)
				}))
			}, (document.attachEvent ? "complete" === document.readyState : "loading" !== document.readyState) ? q() : document.addEventListener("DOMContentLoaded", q)
		}()
}();


var currentPath = window.location.pathname
var navLinks = document.querySelectorAll('.cp_MainNav a');

navLinks.forEach(function(link) {
	if (link.getAttribute('href') === currentPath) {
		link.classList.add('is-active');
		var parentMenuItem = link.closest('.cp_MainNav__menuItem');
		if (parentMenuItem) {
			parentMenuItem.classList.add('cp_MainNav__menuItem--active-trail');
			var expandedParent = parentMenuItem.closest('.cp_MainNav__menuItem--expanded');
			if (expandedParent) {
				expandedParent.classList.add('cp_MainNav__menuItem--active-trail');
			}
		}
	}
});
